import { createContext, useContext } from "react";
import type { EventListeners } from "@/hooks/useEventListeners";

export type WikiFormEvents = {
  submit: () => void;
  cancel: () => void;
  editRequest: () => void;
  deleteRequest: () => void;
};

export const WikiFormContext = createContext<EventListeners<WikiFormEvents> | null>(null);

export const useWikiFormEvents = () => useContext(WikiFormContext);
